<template>
  <div @click="saveToZip()">
    <font-awesome-icon :icon="['far', 'save']" class="icon"></font-awesome-icon>
    {{ t("message.save") }}
  </div>
</template>

//
<script>
import JSZip from "jszip";
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { saveAs } from "file-saver";
import { useI18n } from "vue-i18n";
import { saveInlay } from "@/modules/saveInlay.js";
export default {
  setup() {
    const list = ref([]);
    const store = useStore();
    const currentProject = computed(() => store.getters.currentProject);
    const currentProjectName = computed(() => store.getters.currentProjectName);

    const { t } = useI18n();
    function saveToZip() {
      let zip = new JSZip();
      let date = new Date();
      let now =
        date.getFullYear() + "." + (date.getMonth() + 1) + "." + date.getDate();
      let time = date.getHours() + "_" + date.getMinutes();
      currentProject.value.forEach((inlay) => {
        let saved_inlay = saveAll(inlay);
        zip.file(saved_inlay.name + ".html", saved_inlay.html);
      });
      zip.generateAsync({ type: "blob" }).then(function (content) {
        // see FileSaver.js
        saveAs(
          content,
          currentProjectName.value + "_GT_" + now + "_" + time + ".zip"
        );
      });
    }

    function saveAll(inlay) {
      return saveInlay(inlay);
    }
    function saveSelectedToZip(selectedInlays) {
      let zip = new JSZip();
      let date = new Date();
      let time = date.getHours() + "_" + date.getMinutes();
      selectedInlays.forEach((inlay) => {
        // console.log(inlay);
        let saved_inlay = saveAll(inlay);
        zip.file(saved_inlay.name + ".html", saved_inlay.html);
      });
      zip.generateAsync({ type: "blob" }).then(function (content) {
        // see FileSaver.js
        saveAs(
          content,
          currentProjectName.value +
            "_Auswahl_" +
            selectedInlays.length +
            time +
            ".zip"
        );
      });
    }
    return { saveToZip, list, t };
  },
};
</script>

<style lang="scss" scoped></style>
